module.exports = __webpack_public_path__ + "static/media/bts_veld_170805_006_small.d776a152.jpg";